'use client';
"use strict";

var _excluded = ["children", "placeholder", "className"],
  _excluded2 = ["rootProps", "placeholder", "icon", "color", "height", "h", "minH", "minHeight", "iconColor", "iconSize"],
  _excluded3 = ["children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && _typeof(from) === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};

// src/index.ts
var src_exports = {};
__export(src_exports, {
  Select: function Select() {
    return _Select;
  },
  SelectField: function SelectField() {
    return _SelectField;
  }
});
module.exports = __toCommonJS(src_exports);

// src/select.tsx
var import_form_control = require("@chakra-ui/form-control");
var import_system2 = require("@chakra-ui/system");
var import_shared_utils2 = require("@chakra-ui/shared-utils");

// ../../utilities/object-utils/src/split.ts
function split(object, keys) {
  var picked = {};
  var omitted = {};
  for (var _i = 0, _Object$entries = Object.entries(object); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      key = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    if (keys.includes(key)) picked[key] = value;else omitted[key] = value;
  }
  return [picked, omitted];
}

// src/select.tsx
var import_react = require("react");

// src/select-field.tsx
var import_shared_utils = require("@chakra-ui/shared-utils");
var import_system = require("@chakra-ui/system");
var import_jsx_runtime = require("react/jsx-runtime");
var _SelectField = (0, import_system.forwardRef)(function SelectField2(props, ref) {
  var children = props.children,
    placeholder = props.placeholder,
    className = props.className,
    rest = _objectWithoutProperties(props, _excluded);
  return /* @__PURE__ */(0, import_jsx_runtime.jsxs)(import_system.chakra.select, _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    className: (0, import_shared_utils.cx)("chakra-select", className),
    children: [placeholder && /* @__PURE__ */(0, import_jsx_runtime.jsx)("option", {
      value: "",
      children: placeholder
    }), children]
  }));
});
_SelectField.displayName = "SelectField";

// src/select.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var _Select = (0, import_system2.forwardRef)(function (props, ref) {
  var _a;
  var styles = (0, import_system2.useMultiStyleConfig)("Select", props);
  var _ref = (0, import_system2.omitThemingProps)(props),
    rootProps = _ref.rootProps,
    placeholder = _ref.placeholder,
    icon = _ref.icon,
    color = _ref.color,
    height = _ref.height,
    h = _ref.h,
    minH = _ref.minH,
    minHeight = _ref.minHeight,
    iconColor = _ref.iconColor,
    iconSize = _ref.iconSize,
    rest = _objectWithoutProperties(_ref, _excluded2);
  var _split = split(rest, import_system2.layoutPropNames),
    _split2 = _slicedToArray(_split, 2),
    layoutProps = _split2[0],
    otherProps = _split2[1];
  var ownProps = (0, import_form_control.useFormControl)(otherProps);
  var rootStyles = {
    width: "100%",
    height: "fit-content",
    position: "relative",
    color: color
  };
  var fieldStyles = _objectSpread(_objectSpread({
    paddingEnd: "2rem"
  }, styles.field), {}, {
    _focus: _objectSpread({
      zIndex: "unset"
    }, (_a = styles.field) == null ? void 0 : _a["_focus"])
  });
  return /* @__PURE__ */(0, import_jsx_runtime2.jsxs)(import_system2.chakra.div, _objectSpread(_objectSpread(_objectSpread({
    className: "chakra-select__wrapper",
    __css: rootStyles
  }, layoutProps), rootProps), {}, {
    children: [/* @__PURE__ */(0, import_jsx_runtime2.jsx)(_SelectField, _objectSpread(_objectSpread({
      ref: ref,
      height: h != null ? h : height,
      minH: minH != null ? minH : minHeight,
      placeholder: placeholder
    }, ownProps), {}, {
      __css: fieldStyles,
      children: props.children
    })), /* @__PURE__ */(0, import_jsx_runtime2.jsx)(SelectIcon, _objectSpread(_objectSpread(_objectSpread({
      "data-disabled": (0, import_shared_utils2.dataAttr)(ownProps.disabled)
    }, (iconColor || color) && {
      color: iconColor || color
    }), {}, {
      __css: styles.icon
    }, iconSize && {
      fontSize: iconSize
    }), {}, {
      children: icon
    }))]
  }));
});
_Select.displayName = "Select";
var DefaultIcon = function DefaultIcon(props) {
  return /* @__PURE__ */(0, import_jsx_runtime2.jsx)("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */(0, import_jsx_runtime2.jsx)("path", {
      fill: "currentColor",
      d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
    })
  }));
};
var IconWrapper = (0, import_system2.chakra)("div", {
  baseStyle: {
    position: "absolute",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "none",
    top: "50%",
    transform: "translateY(-50%)"
  }
});
var SelectIcon = function SelectIcon(props) {
  var _props$children = props.children,
    children = _props$children === void 0 ? /* @__PURE__ */(0, import_jsx_runtime2.jsx)(DefaultIcon, {}) : _props$children,
    rest = _objectWithoutProperties(props, _excluded3);
  var clone = (0, import_react.cloneElement)(children, {
    role: "presentation",
    className: "chakra-select__icon",
    focusable: false,
    "aria-hidden": true,
    // force icon to adhere to `IconWrapper` styles
    style: {
      width: "1em",
      height: "1em",
      color: "currentColor"
    }
  });
  return /* @__PURE__ */(0, import_jsx_runtime2.jsx)(IconWrapper, _objectSpread(_objectSpread({}, rest), {}, {
    className: "chakra-select__icon-wrapper",
    children: (0, import_react.isValidElement)(children) ? clone : null
  }));
};
SelectIcon.displayName = "SelectIcon";
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Select: _Select,
  SelectField: _SelectField
});